import {POST} from '../../../js/modules/fetch.ts';
import {queryElems} from '../../../js/utils/dom.ts';
import {fomanticQuery} from '../../../js/modules/fomantic/base.ts';

function initRepoUserGroupAccessMode() {
  for (const dropdownEl of queryElems(document, '.page-content.repository .ui.dropdown.repo-user-group-access-mode')) {
    const textEl = dropdownEl.querySelector(':scope > .text')!;
    const $dropdown = fomanticQuery(dropdownEl);
    $dropdown.dropdown({
      async action(text: string, value: string) {
        dropdownEl.classList.add('is-loading', 'loading-icon-2px');
        const lastValue = dropdownEl.getAttribute('data-last-value')!;
        $dropdown.dropdown('hide');
        let respOk = false;
        try {
          const gid = dropdownEl.getAttribute('data-gid')!;
          const resp = await POST(dropdownEl.getAttribute('data-url')!, {
            data: new URLSearchParams({gid, 'mode': value}),
          });
          respOk = resp.ok;
          if (respOk) {
            textEl.textContent = text;
            dropdownEl.setAttribute('data-last-value', value);
          }
        } finally {
          dropdownEl.classList.remove('is-loading');
          if (!respOk) {
            textEl.textContent = '(error)';
            dropdownEl.setAttribute('data-last-value', lastValue);
          }
        }
      },
      onHide() {
        setTimeout(() => {
          const $item = $dropdown.dropdown('get item', dropdownEl.getAttribute('data-last-value'));
          if ($item) {
            $dropdown.dropdown('set selected', dropdownEl.getAttribute('data-last-value'));
          } else {
            textEl.textContent = '(none)';
          }
        }, 0);
      },
    });
  }
}

export function initRepoSettingsUserGroups() {
  initRepoUserGroupAccessMode();
}
